export const MediaOptions = [
    {
        key: 0,
        text: "None",
        value: "none"
    },
    {
        key: 1,
        text: "Sounds",
        value: "sounds"
    },
    {
        key: 2,
        text: "Pictures",
        value: "pictures"
    }
]
